import type { ReactElement } from "react";

import { AnimatePresence } from "framer-motion";

export function Animatable({
  active,
  children,
  keepAlive,
}: {
  active?: boolean;
  keepAlive?: boolean;
  children: ReactElement;
}) {
  return (
    <AnimatePresence mode="wait">
      {active || keepAlive ? children : null}
    </AnimatePresence>
  );
}
